// Change colours here only.
export const colors = {
  primary: "#0091b3",
  primaryDark: "#002f3a", //app-bar backgorund
  primaryLight: "#06b4dd", // app-bar menu-link text color
  primaryHover: "rgba(6, 180, 221, 0.16)", // app-bar/side-menu link hover background
  primaryIconText: "#0f2a20", // avatar and icons text color like in profile menu icon
  primaryIconBG: "#0aacd2", // avatar and icons bg color like in profile menu icon
  primaryDarkText: "#068cab", // side nav bar selected link text color

  // primary: "#0091b3",
  // primaryDark: "#002419", //app-bar backgorund
  // primaryLight: "#4fd494", // app-bar menu-link text color
  // primaryHover: "rgba(61, 207, 142, 0.14)", // app-bar/side-menu link hover background
  // primaryIconText: "#0f2a20", // avatar and icons text color like in profile menu icon
  // primaryIconBG: "#2bb673", // avatar and icons bg color like in profile menu icon
  // primaryDarkText: "#026d4c", // side nav bar selected link text color

  secondary: "#027f9c",
  secondaryDark: "#027f9c",
} as const;

// "#06b4dd" -> "6, 180, 221" (lets CSS build rgba() at any opacity)
const toRgb = (hex: string): string => {
  const h = hex.replace("#", "");
  const full =
    h.length === 3
      ? h
          .split("")
          .map((c) => c + c)
          .join("")
      : h;
  const n = parseInt(full, 16);
  return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

export const cssVariables = {
  "--sp-primary": colors.primary,
  "--sp-primary-dark": colors.primaryDark,
  "--sp-primary-light": colors.primaryLight,
  "--sp-primary-hover-bg": colors.primaryHover,
  "--sp-primary-icon-text": colors.primaryIconText,
  "--sp-primary-icon-bg": colors.primaryIconBG,
  "--sp-primary-dark-text": colors.primaryDarkText,

  "--sp-secondary": colors.secondary,
  "--sp-secondary-dark": colors.secondaryDark,

  "--sp-primary-rgb": toRgb(colors.primary),
  "--sp-primary-light-rgb": toRgb(colors.primaryLight),

  // Named by purpose, so the CSS says what the colour is for
  "--sp-selected-bg": `rgba(${toRgb(colors.primaryLight)}, 0.16)`,
  "--sp-hover-bg": `rgba(${toRgb(colors.primaryLight)}, 0.08)`,
} as const;
